// What the phone's back button does in the Android app: close an open sheet
// first, from home leave the app, from the other bottom-bar tabs go to home, and
// from pages opened inside a tab go back one step (Android's own convention -
// instead of walking back through every tab visited). With nothing to go back
// to - the app opened straight on a page, e.g. from the Vipps link - go home.
const TAB_PATHS = ["/products", "/coupons", "/login", "/profile"];

export function backAction(pathname, sheetOpen, canGoBack = true) {
  if (sheetOpen) return "history";
  const path = pathname.toLowerCase();
  if (path === "/") return "exit";
  if (TAB_PATHS.includes(path) || !canGoBack) return "home";
  return "history";
}
